export default __webpack_public_path__ + "static/media/img_demo_01_m.0f565b21.webp";